export default function ConfigurationsService($q, $http, appSettings) {
  'ngInject';

  var configurationsEndpoint = appSettings.InReachApiAlertsEndpoint + '/configurations';

  this.postConfiguration = function (configuration) {
    var endpoint = configurationsEndpoint;
    return $http.post(endpoint, configuration);
  };

  this.getConfigurationById = function (id) {
    var endPoint = configurationsEndpoint + '/' + id;
    return $http.get(endPoint);
  };

  this.getConfigurationByName = function (name) {
    var endPoint = configurationsEndpoint + '/name/' + name;
    return $http.get(endPoint);
  };

  this.getAllConfigurations = function () {
    var endpoint = configurationsEndpoint;
    return $http.get(endpoint);
  };

  this.putConfigurationUpdate = function (id, data) {
    var endPoint = configurationsEndpoint + '/' + id;
    return $http.put(endPoint, data);
  };

  this.deleteConfiguration = function (id) {
    var endPoint = configurationsEndpoint + '/' + id;
    return $http.delete(endPoint);
  };

  this.patchConfiguration = function (id, data) {

    var deferred = $q.defer();
    var endpoint = configurationsEndpoint + '/' + id;

    $http.patch(endpoint, data).then(function (configurationResponse) {
      //Return configuration patch response
      deferred.resolve(configurationResponse);
    }, function (configurationError) {
      //Configuration patch error
      deferred.reject(configurationError);
    });

    return deferred.promise;
  };

  this.patchConfigurationEquipment = function (id, data) {
    var endpoint = configurationsEndpoint + '/' + id + '/equipment';
    return $http.patch(endpoint, data);
  };

  this.postConfigurationTrigger = function (id, data) {
    var endpoint = configurationsEndpoint + '/' + id + '/triggers';
    return $http.post(endpoint, data);
  };

  this.deleteConfigurationTrigger = function (id, triggerId) {
    var endpoint = configurationsEndpoint + '/' + id + '/triggers/' + triggerId;
    return $http.delete(endpoint);
  };

  this.updateConfigurationTrigger = function (id, triggerId, trigger) {
    var endpoint = configurationsEndpoint + '/' + id + '/triggers/' + triggerId;
    return $http.put(endpoint, trigger);
  };

}